"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORNER_RADIUS = exports.FLEX_CHILD_SPACING = exports.GRADIENT_STEPS = exports.GRADIENT_SIZE = exports.GRADIENT_OFFSET = exports.GRADIENT_REPEATS = exports.SINGLE_SHADOW_SPREAD = exports.SINGLE_SHADOW_BLUR = exports.SINGLE_SHADOW_DISTANCE = exports.LETTER_SPACING = exports.SIZE_RANGE = exports.EDGE_SIZE = exports.BORDER_WIDTH_DOUBLE = exports.BORDER_WIDTH_SOLID = exports.IMAGE_PATTERN_SCALE = exports.IMAGE_SCALE = exports.COLOR_ADDER_HSB_HUE = exports.COLOR_ADDER_HSB = exports.COLOR_ADDER_RGB = exports.DEGREES_RANGE = exports.PERCENTS_RANGE = void 0;
var consts_1 = require("./consts");
exports.PERCENTS_RANGE = { percents: { min: 0, max: 100 } };
exports.DEGREES_RANGE = { degrees: { min: 0, max: 360, displaySymbol: '\u00B0' } };
exports.COLOR_ADDER_RGB = { unitless: { min: 0, max: 255 } };
exports.COLOR_ADDER_HSB = { unitless: { min: 0, max: 100 } };
exports.COLOR_ADDER_HSB_HUE = { unitless: { min: 0, max: 360 } };
exports.IMAGE_SCALE = { percents: { min: 1, max: 1000, sliderMax: 300 } };
exports.IMAGE_PATTERN_SCALE = { percents: { min: 1, max: 1000, sliderMax: 100 } };
exports.BORDER_WIDTH_SOLID = { pixels: { min: 0, max: 100 } };
exports.BORDER_WIDTH_DOUBLE = { pixels: { min: 3, max: 100 } };
exports.EDGE_SIZE = { pixels: { min: 0 } };
exports.SIZE_RANGE = { pixels: { min: 6, max: 100 } };
exports.LETTER_SPACING = { elements: { min: -0.1, max: 0.7, step: 0.05, shiftStep: 10 } };
exports.SINGLE_SHADOW_DISTANCE = { pixels: { min: 0, max: 15 } };
exports.SINGLE_SHADOW_BLUR = { pixels: { min: 0, max: 100 } };
exports.SINGLE_SHADOW_SPREAD = { pixels: { min: -100, max: 100 } };
exports.GRADIENT_REPEATS = { pixels: { min: 0, max: 10 } };
exports.GRADIENT_OFFSET = { pixels: { min: 0, max: 10 } };
exports.GRADIENT_SIZE = { pixels: { min: 0, max: 100 } };
exports.GRADIENT_STEPS = { pixels: { min: 2, max: 12 } };
exports.FLEX_CHILD_SPACING = { pixels: { min: 0, max: 50 } };
exports.CORNER_RADIUS = {
    pixels: { min: 0, max: consts_1.MAX_INPUT_VALUE },
    elements: { min: 0.5, max: 5, step: 0.1, shiftStep: 1 },
    percents: { min: 0 },
};
//# sourceMappingURL=dimension-input-setup.js.map